"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FuelPricesContractDeployer = void 0;
const autogenerated_1 = require("../autogenerated");
const fs_1 = require("fs");
const path_1 = __importDefault(require("path"));
const fuels_1 = require("fuels");
const FuelPricesContractAdapter_1 = require("./FuelPricesContractAdapter");
const FuelContractConnector_1 = require("../FuelContractConnector");
const PRICES_CONTRACT_BINARY = "../autogenerated/prices.bin";
class FuelPricesContractDeployer extends FuelContractConnector_1.FuelContractConnector {
    constructor(wallet, parameters) {
        super(wallet);
        this.parameters = parameters;
    }
    async getContract() {
        if (this.contract) {
            return this.contract;
        }
        this.contract = await this.deployPricesContract();
        return this.contract;
    }
    async getAdapter() {
        return new FuelPricesContractAdapter_1.FuelPricesContractAdapter(await this.getContract(), this.getGasLimit());
    }
    async deployPricesContract() {
        let bytecode = await this.parameters.contractBinary;
        if (!bytecode) {
            const pricesPath = path_1.default.join(__dirname, PRICES_CONTRACT_BINARY);
            bytecode = (0, fs_1.readFileSync)(pricesPath);
        }
        const factory = new PricesContractFactory(bytecode, autogenerated_1.PricesAbi__factory.abi, this.wallet, this.getGasLimit());
        const storageSlots = this.getStorageSlots();
        const options = { storageSlots };
        if (this.parameters.salt) {
            options["salt"] = this.parameters.salt;
        }
        const contract = (await factory.deployContract(options));
        await contract.functions
            .init(this.parameters.signers.map((signer) => (0, fuels_1.hexZeroPad)(signer, 32)), this.parameters.signerCountThreshold, 0)
            .txParams({
            gasPrice: 1,
            gasLimit: this.getGasLimit(),
        })
            .call();
        return contract;
    }
    getStorageSlots() {
        const FAKE_TIMESTAMP_KEY = "0x66616b655f74696d657374616d70"; // fake_timestamp
        let storageSlots = [];
        if (this.parameters != null) {
            if (this.parameters.fakeTimestamp != null) {
                storageSlots.push({
                    key: FAKE_TIMESTAMP_KEY,
                    value: (0, fuels_1.hexlify)(this.parameters.fakeTimestamp),
                });
            }
        }
        return storageSlots.map(({ key, value }) => {
            return {
                key: (0, fuels_1.hexZeroPad)(key, 32),
                value: (0, fuels_1.hexZeroPad)(value, 32),
            };
        });
    }
}
exports.FuelPricesContractDeployer = FuelPricesContractDeployer;
class PricesContractFactory extends fuels_1.ContractFactory {
    constructor(bytecode, abi, walletOrProvider, gasLimit) {
        super(bytecode, abi, walletOrProvider);
        this.gasLimit = gasLimit;
    }
    createTransactionRequest(deployContractOptions) {
        const { contractId, transactionRequest } = super.createTransactionRequest(deployContractOptions);
        transactionRequest.gasLimit = new fuels_1.BN(this.gasLimit);
        transactionRequest.gasPrice = new fuels_1.BN(1);
        return { contractId, transactionRequest };
    }
}
//# sourceMappingURL=FuelPricesContractDeployer.js.map